export enum ENV {
    PROD = 'prod',
    STAGING = 'staging',
    EU_PROD = 'euprod',
    QA = 'qa',
    DEV = 'dev',
    EU_DEV = 'eudev',
    QA_DEV = 'qadev'
}

export const isProdEnv = (env: ENV): boolean => {
    return env === ENV.PROD || env === ENV.EU_PROD;
};

export const getEnvByOrigin = (origin: string): ENV => {
    if (process.env.REACT_APP_EUDEV === '1') return ENV.EU_DEV;
    if (process.env.REACT_APP_QADEV === '1') return ENV.QA_DEV;
    if (process.env.NODE_ENV === 'development') return ENV.DEV;

    if (origin.indexOf('walkmeqa') >= 0) return ENV.QA;
    if (origin.indexOf('eu-') >= 0) return ENV.EU_PROD;
    if (origin.indexOf('staging') >= 0) return ENV.STAGING;
    return ENV.PROD;
};
